<template>
  <div>
    <b-carousel id="carousel-1" indicators  background="#ababab">
      <b-carousel-slide v-for="(item, index) in slider" v-bind:key="index">
        <template #img>
          <div
            class="w-100 home-slider-img"
            alt="image slot"
            :style="`background: url('${item.img}') no-repeat top center scroll;background-size: cover;`"
          >
            <div class="w-100 row align-items-center home-slider">
              <div class="col fontsiyuanmedium">
                <div class="indexslider-subtitle fontsiyuanregular">
                  {{ $t(`homeslide[${index}].title`) }}
                </div>
                <div class="indexslider-title fontsiyuanmedium">
                  {{ $t(`homeslide[${index}].subtitle`) }}
                </div>
                <div
                  class="indexslider-goal fontsiyuannormal"
                  style="font-weight: bold"
                >
                  {{ $t(`homeslide[${index}].goal`) }}
                </div>
                <div class="indexslider-button">
                  <a @click="routerView($t(`homeslide[${index}].buttonurl`))"><span>{{ $t(`homeslide[${index}].button`) }}</span></a>
                </div>
              </div>
            </div>
          </div>
          <div class="row align-items-center"></div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    banner: {
      type: String,
    },
  },
  data() {
    return {
      slotHeight: 0,
      slide: 0,
      sliding: null,
      slider: [],
    };
  },
  created() {
    this.getSlider();
  },
  methods: {
    getSlider() {
      const _this = this;
      this.$store.dispatch("getSlider").then((x) => {
        console.log(x)
        let en = {};
        let zh = {};
        en[x.title] =JSON.parse(x.en) ;
        zh[x.title] =JSON.parse(x.zh) ;
        _this.slider=JSON.parse(x.zh) ;
        console.log('slide',new Date().getTime());
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

      });
    },
    routerView(url){
      this.$router.push(url)
    }
  },
};
</script>
<style>
.home-slider {
  height: 50vw;
  max-height: 600px;
  width: 100vw;
  /*图片的宽高为440*440，而元素相对区域高度为50 */
}
.home-slider-img {
  height: 50vw;
  max-height: 600px;
  width: 100vw;
}

@media only screen and (max-width: 500px) {
  .home-slider {
    height: 80vw;
    width: 100vw;
    /*图片的宽高为440*440，而元素相对区域高度为50 */
  }
  .home-slider-img {
    height: 100vw;
    width: 100vw;
  }
}
</style>
